import { ReducerRegistry } from 'store';
import { FETCH_SETTLEMENT_LOGS, FETCH_SETTLEMENT_DETAILS_LOGS } from '../types';

const INIT_STATE = {
  settlementList: [],
  settlementTotal: 0,
  detailsList: [],
  detailsTotal: 0,
};

export const settlementssReducer = ReducerRegistry.register(
  'settlements',
  (state = INIT_STATE, { type, payload }) => {
    switch (type) {
      case FETCH_SETTLEMENT_LOGS:
        return {
          ...state,
          settlementList: payload.list,
          settlementTotal: payload.total,
        };
      case FETCH_SETTLEMENT_DETAILS_LOGS:
        return {
          ...state,
          detailsList: payload.list,
          detailsTotal: payload.total,
        };
      default:
        return state;
    }
  }
);
